import { render, staticRenderFns } from "./NotificationNav.vue?vue&type=template&id=a9c432bc&"
import script from "./NotificationNav.vue?vue&type=script&lang=js&"
export * from "./NotificationNav.vue?vue&type=script&lang=js&"
import style0 from "./NotificationNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports